import React from "react";
import GPMSIntro from "./Gpmsintro";
import GPMSCapabilities from "./Gpmscapabilities";
import CapabilityDetail from "./Capabilitydetail";
import { DETAILS } from "./Gpmsdata";
import "./Gpms.css";
 
// Hero section alag se (GPMSHero) upar lagana ho to yahan import karke
// <GPMSHero /> ko <GPMSIntro /> se pehle add kar do.
const GPMSPage = () => (
  <main className="gp-page">
    <GPMSIntro />
    <GPMSCapabilities />
    {DETAILS.map((d, i) => (
      <CapabilityDetail key={d.id} data={d} index={i} />
    ))}
  </main>
);
 
export default GPMSPage;